<template>
  <div class="studentMessageHome">
    <div class="navBox" >
      <div class="navRight">
        <ul style="width:350px">
          <router-link v-for="(item,index) in navRight" :key="index" tag="li" :to="item.path">{{item.name}}</router-link>
        </ul>
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "index",
  data(){
    return {
      active: 0,
      navRight:[
        { name: '目标拆分', idx: '0', path: '/parent/main/implement/targetsplit' },
        { name: '行动计划', idx: '1', path: '/parent/main/implement/actionplan' },
        { name: '阶段评估', idx: '2', path: '/parent/main/implement/assessment' }
      ],
      query:''
    }
  },
  mounted() {

  }
}
</script>

<style lang="less" scoped>
.studentMessageHome {
  .navBox {
    background-color: #fff;
    padding: 10px 30px 24px 30px;
    .navRight {
      height: 55px;
      border-bottom: 1px solid rgba(217, 217, 217, 1);
      box-sizing: border-box;
      ul{
        display: flex;
        justify-content: space-between;
      }
      li {
        box-sizing: border-box;
        height: 54px;
        line-height: 54px;
        font-size: 17px;
        font-weight: 500;
        cursor: pointer;
      }

      .router-link-active {
        border-bottom: 2px solid #3D90F6;
        color: #3D90F6;
      }
    }
  }
}
</style>